import React from "react";
import styled from "styled-components";
import { Loading } from "../Loading";
import { LoadingColor } from "../LoadingColor";
const Styles = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0.2rem 0;
  .text-btn {
    cursor: pointer;
    width: calc(100%);
    padding: calc(var(--fs-textfield) / 1.5) 1rem;
    border-radius: var(--border-radius-1);
    border: none;
    outline: none;
    transition: var(--trans-1);
    font-size: var(--fs-textfield);
    background-color: var(--prime-1);
    color: var(--n-grey-0);
    fill: var(--n-grey-0);
    display: flex;
    justify-content: center;
    gap: 0.3rem;
    align-items: center;
    white-space: nowrap;
    min-height: 48px;
    .with-icon {
      width: 100%;
      justify-content: center;
      display: flex;
      gap: 0.25rem;
      align-items: center;
      font-weight: 700;
      min-width: 150px;
    }
    .simple-text {
      min-height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    svg {
      fill: var(--n-grey-0);
    }
    font-weight: 500;
    &.link {
      text-decoration: none;
      width: calc(100% - 2rem);
    }
    &.btn-type-0 {
      background-color: var(--white-1-o);
      color: var(--white-1);
      border: 1px solid var(--white-1);
      border-radius: var(--border-radius-2);
      svg {
        fill: var(--white-1);
      }
      &:hover {
        background-color: var(--white-1-o2);
      }
    }
    &.btn-type-1 {
      background-color: var(--white-1-o);
      color: var(--main-color);
      border: 1px solid var(--main-color);
      border-radius: var(--border-radius-3);
      svg {
        fill: var(--main-color);
      }
      &:hover {
        background-color: var(--white-1-o2);
      }
    }
    &.btn-type-2 {
      background-color: var(--main-color);
      color: var(--n-grey-0);
      border: 1px solid var(--main-color);
      border-radius: var(--border-radius-3);
      &:hover {
        color: var(--main-color);
        background-color: var(--secn-color);
      }
    }
    &.btn-type-3 {
      background-color: var(--white-1-o);
      color: var(--main-color);
      border: 1px solid var(--main-color);
      border-radius: 1000px;
      padding: var(--fs-textfield) 1rem;
      min-height: auto;
      svg {
        fill: var(--main-color);
      }
      &:hover {
        background-color: var(--white-1-o2);
      }
    }
    &:hover {
      background-color: var(--prime-2);
    }
    &:disabled {
      background-color: var(--n-grey-1);
      color: var(--n-grey-3);
    }
  }
  .error {
    display: flex;
    height: 1rem;
    font-size: var(--fs-small);
    .icon {
      text-align: center;
      width: 1rem;
      height: 1rem;
    }
    .text {
      margin: 0 0.2rem 0 0;
    }
  }
  @media screen and (max-width: 1445px) {
    .text-field {
      padding: 0.5rem 1rem;
    }
  }
  @media screen and (max-width: 800px) {
  }
`;

export const TextBtn2 = ({
  style,
  className,
  classname,
  type,
  name,
  text,
  onclick,
  disabled,
  loading,
  newType = 0,
  link,
}) => {
  let classes = "text-btn";
  if(newType === 0) {
    classes+= " btn-type-0"
  }
  if(newType === 1) {
    classes+= " btn-type-1"
  }
  if(newType === 2) {
    classes+= " btn-type-2"
  }
  if(newType === 3) {
    classes+= " btn-type-3"
  }
  if (loading) {
    return (
      <Styles style={style} className={classname}>
        <button
          type={type}
          className={classes + ' ' +className}
          name={name}
          onClick={onclick}
          disabled={disabled}
        >
          <LoadingColor small={true}/>
        </button>
      </Styles>
    );
  }
  if(link){
    return (
      <Styles style={style} className={classname}>
        <a
          type={type}
          className={classes + ' link' + " " + className}
          name={name}
          disabled={disabled}
          href={link}
        >
          {text}
        </a>
      </Styles>
    );
  }
  return (
    <Styles style={style} className={classname}>
      <button
        type={type}
        className={classes + " " + className}
        name={name}
        onClick={onclick}
        disabled={disabled}
      >
        {text}
      </button>
    </Styles>
  );
};
